import { useState } from 'react';

export const SnackbarStateUnsuc = () => {
    const [alert, setAlert] = useState({ isOpen: false, textBody: ""})

    return {
        alertVal: {data: alert, set: setAlert}
    }
}